import { render, staticRenderFns } from "./initStatus.vue?vue&type=template&id=164b737c&scoped=true"
import script from "./initStatus.vue?vue&type=script&lang=js"
export * from "./initStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b737c",
  null
  
)

export default component.exports